import React, { useState } from 'react';
import { useSetRecoilState } from 'recoil';

import { defaultApi } from '../../apis';
import { DataInterfaceType } from '../../../gamma-api';
import IbIcon from '../common/IbIcon';
import { alertsSelectorAdd } from '../../recoil';
import { getTranslateFunc } from '../../utils/stringUtil';
import { downloadNamedFile } from '../../utils/fileUtil';
import ProgressPanel from '../ProgressPanel';

interface IAgentExportProps {
  interfaceType: DataInterfaceType;
  agentId: string;
}

const AgentExport: React.FC<IAgentExportProps> = ({ interfaceType, agentId, children }) => {
  const translatePrefix = interfaceType === DataInterfaceType.Api ? 'API' : 'Chat';
  const translate = getTranslateFunc(`Agent: Export: ${translatePrefix}:`);

  const addAlert = useSetRecoilState(alertsSelectorAdd);

  const [progressPanelVisible, setProgressPanelVisible] = useState(false);

  const onExportClick = async () => {
    setProgressPanelVisible(true);
    try {
      const response = await defaultApi.exportAgentArchive(agentId, { responseType: 'blob' });
      downloadNamedFile(response);
    } catch (e) {
      addAlert({
        content: translate('Error'),
        type: 'error',
        icon: <IbIcon iconName="attention" />,
      });
      // eslint-disable-next-line no-console
      console.error(e);
    }
    setProgressPanelVisible(false);
  };

  return (
    <>
      <span role="button" tabIndex={0} onClick={onExportClick}>
        {children}
      </span>
      <ProgressPanel.AgentExport visible={progressPanelVisible} />
    </>
  );
};

export default AgentExport;
